import React, { useState, useEffect } from "react";
import { useUser } from "./../../Home/UserContext";
import { getRoleFromRoleId } from "./../../../utils/roleHelper";
import DashboardNavigation from "./../../DashboardNavigation/DashboardNavigation";
import useScrollToTop from "./../../../hooks/useScollToTop";
import { ToastContainer, toast } from "react-toastify";
import Button from "./../../../components/Button/Button";
import PageList from "./PageList";
import CreatePageModal from "./CreatePageModal";
import EditPageModal from "./EditPageModal";
import ManageArticlesModal from "./ManageArticlesModal";

import {
  getAllPages,
  deletePage,
} from "./../../../services/pagesPersonnaliseesServices";
import "react-toastify/dist/ReactToastify.css";

const PagesPersonnalisees = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  const [pages, setPages] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [pageToEdit, setPageToEdit] = useState(null);
  const [showArticlesModal, setShowArticlesModal] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);

  // Charger les pages
  const loadPages = async () => {
    const result = await getAllPages();
    setPages(result);
  };

  useEffect(() => {
    loadPages();
  }, []);

  const handleDeletePage = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cette page ?")) {
      const res = await deletePage(id);
      if (res) {
        toast.success("Page supprimée avec succès");
        loadPages();
      } else {
        toast.error("Erreur lors de la suppression");
      }
    }
  };

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] dark:text-white">
      <h2 className="text-2xl font-light tracking-[0.3em] text-center mb-2">
        ADMINISTRATEUR
      </h2>
      <h2 className="text-3xl font-bold uppercase tracking-widest text-center mb-4 font-montserrat">
        Pages Personnalisées
      </h2>
      <DashboardNavigation role={userRole} />

      <div className="flex flex-col items-center w-full px-4 mt-4 max-w-[1280px] mx-auto">
        <Button
          text="Créer une nouvelle page"
          onClick={() => setShowCreateModal(true)}
          className="mb-4"
        />

        <PageList
          pages={pages}
          onEdit={(page) => {
            setPageToEdit(page);
            setShowEditModal(true);
          }}
          onDelete={handleDeletePage}
          onManageArticles={(page) => {
            setSelectedPage(page);
            setShowArticlesModal(true);
          }}
        />
      </div>

      {showCreateModal && (
        <CreatePageModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onCreateSuccess={() => {
            setShowCreateModal(false);
            loadPages();
          }}
        />
      )}

      {showEditModal && (
        <EditPageModal
          isOpen={showEditModal}
          page={pageToEdit}
          onClose={() => setShowEditModal(false)}
          onSuccess={() => {
            setShowEditModal(false);
            loadPages();
          }}
        />
      )}

      {showArticlesModal && (
        <ManageArticlesModal
          page={selectedPage}
          onClose={() => setShowArticlesModal(false)}
        />
      )}

      <ToastContainer />
    </div>
  );
};

export default PagesPersonnalisees;
